module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("通话转写词表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "错词"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "错词或原词"
    },
    model: {
      value: (_vm.queryParam.srcWord),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "srcWord", $$v)
      },
      expression: "queryParam.srcWord"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.enabled),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "enabled", $$v)
      },
      expression: "queryParam.enabled"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/callAsrWord/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑词条' : '新增词条',
      "width": "520"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "错词"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "识别错了的词，如哈斯理"
    },
    model: {
      value: (_vm.form.srcWord),
      callback: function($$v) {
        _vm.$set(_vm.form, "srcWord", $$v)
      },
      expression: "form.srcWord"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "正确词"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "替换成的正确词，如HelloKid"
    },
    model: {
      value: (_vm.form.dstWord),
      callback: function($$v) {
        _vm.$set(_vm.form, "dstWord", $$v)
      },
      expression: "form.dstWord"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a74808","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/CallAsrWord.vue
// module id = 1680
// module chunks = 8